import { Container, Grid2, Link } from '@mui/material'
import React from 'react'
import { i18n } from '../index'

declare global {
  interface Window {
    UC_UI?: {
      showSecondLayer: () => void
    }
  }
}

export default function Footer() {
  function handleShowSecondLayer() {
    if (window.UC_UI && window.UC_UI.showSecondLayer) {
      window.UC_UI.showSecondLayer()
    }
  }

  return (
    <>
      <Container sx={{ bottom: 0, paddingTop: '2em' }}>
        <Grid2 justifyItems={'center'} flexDirection='row'>
          <Grid2>
            <Link sx={{ bottom: '1em' }} variant='button' href='#' onClick={handleShowSecondLayer}>
              {i18n.t('common.cookieSettingsLink')}
            </Link>
          </Grid2>
        </Grid2>
      </Container>
    </>
  )
}
